/**
 * DUNAMIS WEAR — Drawer System
 */
(function () {
  'use strict';
  const theme = window.theme;
  let releaseFocus = null;

  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (theme.trapFocus) releaseFocus = theme.trapFocus(drawer.querySelector('.drawer__panel'));
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (releaseFocus) { releaseFocus(); releaseFocus = null; }
  }

  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer(openBtn.getAttribute('data-drawer-open'));
      return;
    }
    const closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) {
      const drawer = closeBtn.closest('.drawer, [data-drawer]');
      if (drawer) closeDrawer(drawer);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer.is-open, [data-drawer].is-open').forEach(closeDrawer);
    }
  });

  theme.openDrawer = openDrawer;
  theme.closeDrawer = closeDrawer;
})();
